export default __webpack_public_path__ + "static/media/block.cf498eb3.svg";